import { SwapCard, SwapMobileCard } from 'src/components';
import { SwapStatus } from 'src/constants';
import { CardContainer, Container } from './styles';

const TestPage = () => {
  return (
    <Container>
      <SwapMobileCard />
      <CardContainer>
        <SwapCard status={SwapStatus.CONFIRMING} />
      </CardContainer>
      <CardContainer>
        <SwapCard status={SwapStatus.IN_QUEUE} />
      </CardContainer>
      <CardContainer>
        <SwapCard status={SwapStatus.COMPLETED} />
      </CardContainer>
    </Container>
  );
};

export default TestPage;
